<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{$t('Ga terug')}}
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Mail details')}}
                            </div>
                        </div>
                        <table v-if="!loading" class="ak-table ak-panel__table">
                            <tbody>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Onderwerp') }}:
                                    </td>
                                    <td class="ak-table-column">
                                        {{ mailLog.subject }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Van') }}:
                                    </td>
                                    <td class="ak-table-column">
                                        {{ mailLog.from }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Naar') }}:
                                    </td>
                                    <td class="ak-table-column">
                                        {{ mailLog.to }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Body') }}:
                                    </td>
                                    <td class="ak-table-column" v-html="mailLog.body">
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Datum verzonden') }}:
                                    </td>
                                    <td class="ak-table-column">
                                        {{ mailLog.date | date-relative }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-4">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailLogOverview',
    data() {
        return {
            mailLog: null,
            loading: false,
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/mail-log-overview/' + this.$route.params.hashId);
            if (result.success) {
                this.mailLog = result.data;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'mail-log', gridDefinition: 'grid'}});
        },
    },
    created() {
        this.initialize();
    }
}
</script>
